import { render } from "./icon-logo.vue?vue&type=template&id=32579f57"
import script from "./icon-logo.vue?vue&type=script&lang=js"
export * from "./icon-logo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__